<template>
  <modal ref="modal" :title="$t('situations.releaseDate')" action="Modifier" :loading="loading" @create="editReleaseDate">
    <button class="button is-small is-primary" slot="activator"><i class="fa fa-pencil"></i></button>

    <date-field
      :label="$t('situations.releaseDate')"
      v-model="releaseDate"
      :edit="true" />
  </modal>
</template>

<script>
import axios from "axios";

export default {
  name: "ReleaseDateModal",
  props: {
    situation: {
      type: Object,
      required: true
    },
    attachement: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      releaseDate: this.attachement.rgReleaseDate,
      loading: false
    }
  },
  watch: {
    attachement: {
      handler() {
        this.releaseDate = this.attachement.rgReleaseDate;
      },
      deep: true
    }
  },
  methods: {
    editReleaseDate() {
      this.loading = true;
      axios.put(`/attachement/${this.attachement.id}/warranties/releaseDate`, { releaseDate: this.releaseDate }).then(() => {
        this.$awn.success("Date de libération modifiée avec succès");
        this.$refs.modal.close();
      }).finally(() => {
        this.$emit('update');
        this.loading = false;
      });
    }
  }
}

</script>
